// src/tooltip.store.ts
import { proxy } from "@zag-js/core";
var store = proxy({
  id: null,
  prevId: null,
  setId(val) {
    this.prevId = this.id;
    this.id = val;
  }
});

export {
  store
};
